/**
 * Card / shell concave frame (framed-product-showcase only).
 * Targets [data-fps-card-frame] — does not touch special-framed-image.
 */
(function () {
  const BASE_WIDTH = 1000;

  function compact(s) {
    return s.replace(/\s+/g, " ").trim();
  }

  function buildPaths(r, gap, W, H) {
    const outerPath = `
      M ${r} 0
      H ${W - r}
      C ${W - r} 0 ${W - r} ${r} ${W} ${r}
      V ${H - r}
      C ${W - r} ${H - r} ${W - r} ${H} ${W - r} ${H}
      H ${r}
      C ${r} ${H} ${r} ${H - r} 0 ${H - r}
      V ${r}
      C ${r} ${r} ${r} 0 ${r} 0
      Z
    `;

    const ir = r;
    const ig = gap;

    const innerPath = `
      M ${ir + ig} ${ig}
      H ${W - ir - ig}
      C ${W - ir - ig} ${ig}
        ${W - ir - ig} ${ir + ig}
        ${W - ig} ${ir + ig}
      V ${H - ir - ig}
      C ${W - ir - ig} ${H - ir - ig}
        ${W - ir - ig} ${H - ig}
        ${W - ir - ig} ${H - ig}
      H ${ir + ig}
      C ${ir + ig} ${H - ig}
        ${ir + ig} ${H - ir - ig}
        ${ig} ${H - ir - ig}
      V ${ir + ig}
      C ${ir + ig} ${ir + ig}
        ${ir + ig} ${ig}
        ${ir + ig} ${ig}
      Z
    `;

    return { outerPath: compact(outerPath), innerPath: compact(innerPath) };
  }

  function getViewBox(frame) {
    const rect = frame.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) {
      return { W: BASE_WIDTH, H: BASE_WIDTH };
    }
    const W = BASE_WIDTH;
    const H = Math.max(100, Math.round(W * (rect.height / rect.width)));
    return { W, H };
  }

  function applyCardFrameGeometry(frame) {
    const inner = frame.querySelector(".inner-border");
    const shape = frame.querySelector(".shape-path");
    const fill = frame.querySelector(".frame-fill");
    const slot = frame.querySelector(".special-frame__slot");
    const svg = frame.querySelector(".frame-svg");

    if (!inner || !shape) return;

    const styles = getComputedStyle(frame);
    const r = parseFloat(styles.getPropertyValue("--corner-radius")) || 20;
    const gap = parseFloat(styles.getPropertyValue("--inner-gap")) || 10;
    const borderWidth = parseFloat(styles.getPropertyValue("--border-width")) || 2;
    const borderColor = styles.getPropertyValue("--border-color").trim() || "#2a2a2a";
    const fillColor = styles.getPropertyValue("--fill-color").trim() || "#f7f4ef";

    const { W, H } = getViewBox(frame);

    if (svg) {
      svg.setAttribute("viewBox", `0 0 ${W} ${H}`);
      svg.setAttribute("preserveAspectRatio", "xMidYMid meet");
    }

    if (fill) {
      fill.setAttribute("width", W);
      fill.setAttribute("height", H);
      fill.setAttribute("fill", fillColor);
    }

    const { outerPath, innerPath } = buildPaths(r, gap, W, H);

    shape.setAttribute("d", outerPath);
    inner.setAttribute("d", innerPath);
    inner.setAttribute("stroke", borderColor);
    inner.setAttribute("stroke-width", String(borderWidth));

    /* Content padding: configured in section CSS (--fps-card-padding-*), not here */
  }

  function bindCardFrame(frame) {
    applyCardFrameGeometry(frame);

    if (frame.dataset.fpsCardFrameResizeBound === "true") return;
    frame.dataset.fpsCardFrameResizeBound = "true";

    const resize = () => applyCardFrameGeometry(frame);
    if (typeof ResizeObserver !== "undefined") {
      const observer = new ResizeObserver(resize);
      observer.observe(frame);
      frame._fpsCardFrameResizeObserver = observer;
    } else {
      window.addEventListener("resize", resize);
    }
  }

  function init(root) {
    const scope = root && root.nodeType ? root : document;
    scope.querySelectorAll("[data-fps-card-frame]").forEach(bindCardFrame);
  }

  window.initFpsCardFrames = init;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init(document));
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", (event) => {
    init(event.target || document);
  });

  if (typeof Shopify !== "undefined" && Shopify.designMode) {
    window.setInterval(() => {
      document.querySelectorAll("[data-fps-card-frame]").forEach(applyCardFrameGeometry);
    }, 150);
  }
})();
